"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lookup_1 = __importDefault(require("../lookup"));
exports.default = {
    types: lookup_1.default,
    rpc: {},
};
//# sourceMappingURL=definitions.js.map